import './App.css';
import Home from './pages/Home';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import HomeDark from './pages/dark/Home';
import Blogs from './pages/dark/blogs';
import Works from './pages/dark/works';
import SingleProject from './pages/dark/single-project';
import ScotiaBank from './pages/dark/scotiabank';
import Bombardier from './pages/dark/bombardier';
import TechMahindra from './pages/dark/techmahindra';
import Freelance from './pages/dark/freelance';
import Deloitte from './pages/dark/deloitte';
import Aspirezone from './pages/dark/aspirezone';
import Sony from './pages/dark/sony';
import Zome from './pages/dark/zome';
import Cibc from './pages/dark/cibc';
import Sunlife from './pages/dark/sunlife';
import Ford from './pages/dark/ford';
import HomeLight from './pages/light/Home';
import LightBlogs from './pages/light/blogs';
import LightSingleBlog from './pages/light/single-blog';
import LightSingleProject from './pages/light/single-project';
import LightWorks from './pages/light/works';
import SingleBlog from './pages/dark/single-blog';
function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/dark" element={<HomeDark />} />
        <Route path="/blogs" element={<Blogs />} />
        <Route path="/works" element={<Works />} />
        <Route path="/single-project" element={<SingleProject />} />
        <Route path="/scotiabank" element={<ScotiaBank />} />
        <Route path="/bombardier" element={<Bombardier />} />
        <Route path="/techmahindra" element={<TechMahindra />} />
        <Route path="/freelance" element={<Freelance />} />
        <Route path="/deloitte" element={<Deloitte />} />
        <Route path="/aspirezone" element={<Aspirezone />} />
        <Route path="/sony" element={<Sony />} />
        <Route path="/cibc" element={<Cibc />} />
        <Route path="/ford" element={<Ford />} />
        <Route path="/sunlife" element={<Sunlife />} />
        <Route path="/zome" element={<Zome />} />
        <Route path="/single-blog" element={<SingleBlog />} />
        <Route path="/light-m" element={<HomeLight />} />
        <Route path="/l-blogs" element={<LightBlogs />} />
        <Route path="/l-single-blog" element={<LightSingleBlog />} />
        <Route path="/l-single-project" element={<LightSingleProject />} />
        <Route path="/l-works" element={<LightWorks />} />
      </Routes>
    </Router>
  );
}

export default App;
